import StatsIcon from "../../../assets/icons/StatsIcon";
import { useRef } from 'react';
import { useOutsideDrop } from '../../../hooks/useOutsideDrop';
import { Container, Export, LI, UL } from './styles'




export const ExportButton = ({ style, options, openState }) => {
    const [open, setOpen] = openState;

    const exportRef = useRef()


    useOutsideDrop(exportRef, () => setOpen(false))


    return (
        <Container ref={exportRef} style={style}>
            <Export onClick={() => setOpen(!open)}>
                <StatsIcon />
                <span>Exportar</span>
            </Export>
            {<UL open={open}>
                {options.map(op => <LI onClick={op.click ? op.click : null} key={Math.random()}>{op.link ? op.link : op.name}</LI>)}
            </UL>
            }

        </Container >
    )
}